// Point d'entrée du site de Stef, chargé par index.html. Le contenu et sa mise en page n'en
// dépendent pas : ce script ajoute la navigation, et ce qui bouge. Les deux modules sont communs
// aux sites (commun/web/, alias @commun) : un correctif s'y fait une fois, pour les deux.

import { monterMouvement } from '@commun/mouvement/mouvement.ts';
import { monterLigneDeTemps } from '@commun/navigation/ligne-de-temps.ts';

const demonterNavigation = monterLigneDeTemps();
const demonterMouvement = monterMouvement();

// Rechargement à chaud : un changement de la navigation ou du mouvement les remonte sans
// recharger la page.
if (import.meta.hot) {
  import.meta.hot.accept();
  import.meta.hot.dispose(() => {
    demonterMouvement();
    demonterNavigation();
  });
}
